/**
 * Program creation flow V2 — GA for all orgs: the `programCreationFlowV2` org
 * flag is no longer read.
 *
 * Kept (name + signature) so the call sites that branch on it keep compiling.
 * It covers the program-creation-flow revamp (PRD "Program Creation Flow
 * Changes"): Continue resumes into the embedded Elliott wizard or the widened
 * standalone aimd-v2 resume, the Members step, "Publish" / "Invite & Finish"
 * with deferred audience enrollment, and the post-creation editor AI CTAs.
 */
const useProgramCreationFlowV2 = (): boolean => true;

export default useProgramCreationFlowV2;
